
if (window.location.pathname.includes("/collections/")) {
  const pathSegments = window.location.pathname.split('/');
  const collectionHandle = pathSegments[pathSegments.length - 1] || pathSegments[pathSegments.length - 2]; // in case the URL ends with a '/'
  sessionStorage.setItem('lastCollection', collectionHandle);
  console.log(sessionStorage.getItem('lastCollection'));
} else {
  if (!window.location.pathname.includes("/products/")) {
    console.log("not on collection page");
    sessionStorage.removeItem('lastCollection');
  }
}

document.addEventListener("DOMContentLoaded", function() {
  var linksWithDataAttribute = document.querySelectorAll('[data-url]');
// console.log("linksWithDataAttribute", linksWithDataAttribute)
  linksWithDataAttribute.forEach(function(link) {
    link.addEventListener("click", function(e) {
      e.preventDefault(); // Prevent the default link behavior

      var dataFollowLink = link.getAttribute("data-url");

      if (dataFollowLink) {
        window.location.href = dataFollowLink; // Navigate to the data URL
      }
    });
  });
});

$(document).on('product:added product:removed', function() {
  $('.free-shipping-remaining-text').text('New Shipping Text');
});

// Quick add to cart
function addProductToCart(id, productId){
  const formData = {
    id: id,
    quantity: 1
  };

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify(formData),
    dataType: 'json',
    headers: {
      'Content-Type': 'application/json'
    },
    beforeSend: function(){
      buttonLoading(productId)
    },
    success: function(cart) {
      buttonStopLoading(productId)
      
      $.getJSON('/cart.js', function(updatedCart) {
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          detail: {
            cart: updatedCart
          }
        }));
      });        
        
      const cartDrawerElement = document.querySelector('#cart-drawer');
      if (cartDrawerElement) {
        cartDrawerElement.show();
      } 
        
    },
    error: function(errorThrown) {
      buttonStopLoading(productId)

        var r = jQuery.parseJSON(errorThrown.responseText);
        $(".error_" + pro_id).html("Error: " + r.description).show();
        setTimeout(function() {
            $(".error_" + pro_id).html("").hide(100);
        }, 3000);
      }
  });
  
}

function buttonLoading(productId){
  $(`.loading-${productId}`).removeClass('noopacity');
  $(`.add-text-${productId}`).addClass('noopacity');
  $(`.button-${productId}`).prop('disabled', true);
  $(`.button-${productId}`).addClass('button-disabled');
}
function buttonStopLoading(productId){
  $(`.loading-${productId}`).addClass('noopacity');
  $(`.add-text-${productId}`).removeClass('noopacity');
  $(`.button-${productId}`).prop('disabled', false);
  $(`.button-${productId}`).removeClass('button-disabled');
}

CONVERT_HARNESS_MAPPING = {
  "2XS": { patch: "100mm", d_ring: "25mm" },
  "XS": { patch: "100mm", d_ring: "25mm" },
  "S": { patch: "130mm", d_ring: "38mm" },
  "M": { patch: "130mm", d_ring: "38mm" },
  "L": { patch: "158mm", d_ring: "50mm" },
  "XL": { patch: "158mm", d_ring: "50mm" },
  "2XL": { patch: "158mm", d_ring: "50mm" }
}

EXPRESS_HARNESS_MAPPING = {
  "2XS": { patch: "100mm", d_ring: "25mm" },
  "XS": { patch: "100mm", d_ring: "25mm" },
  "S": { patch: "110mm", d_ring: "25mm" },
  "M": { patch: "130mm", d_ring: "38mm" },
  "L": { patch: "130mm", d_ring: "38mm" },
  "XL": { patch: "158mm", d_ring: "50mm" },
  "2XL": { patch: "158mm", d_ring: "50mm" }
}

SADDLE_BAGS_MAPPING = {
  "S": { patch: "110mm", d_ring: "25mm" },
  "L": { patch: "155mm", d_ring: "50mm" }
}

BACK_PACK_MAPPING = {
  "S": { patch: "110mm", d_ring: "" },
  "M": { patch: "110mm", d_ring: "" },
  "L": { patch: "110mm", d_ring: "" }
}

ORTHO_SMART_BED_MAPPING = {
  "S": { patch: "110mm", d_ring: "" },
  "M": { patch: "130mm", d_ring: "" },
  "L": { patch: "130mm", d_ring: "" },
  "XL": { patch: "130mm", d_ring: "" }
}

ORTHO_LOUNGER_MAPPING = {
  "M": { patch: "110mm", d_ring: "" },
  "L": { patch: "130mm", d_ring: "" },
  "XL": { patch: "130mm", d_ring: "" }
}

ORTHO_CALM_ELITE_BED_MAPPING = {
  "M": { patch: "110mm", d_ring: "" },
  "L": { patch: "130mm", d_ring: "" },
  "XL": { patch: "130mm", d_ring: "" }
}

FORMFIT_MAPPING = {
  "2XS": { patch: "50mm", d_ring: "" },
  "XS": { patch: "50mm", d_ring: "" },
  "S": { patch: "65mm", d_ring: "" },
  "M": { patch: "65mm", d_ring: "" },
  "L": { patch: "80mm", d_ring: "" },
  "XL": { patch: "80mm", d_ring: "" }
}

// Product IDS will be set under ids (convert harness will require getting all the convert harness ids for instance)
// Mapping from product size to patch/dring etc will be set up above

window.mapping = [
  {
    product: "Convert harness",
    ids: [8785890607400, 8785901584680, 8785899946280, 8785898176808],
    mapping: CONVERT_HARNESS_MAPPING
  },
  {
    product: "Express harness",
    ids: [8785890935080, 8785901682984, 8785900044584, 8785898307880],
    mapping: EXPRESS_HARNESS_MAPPING
  },
  {
    product: "Saddle bags",
    ids: [8785884709160],
    mapping: SADDLE_BAGS_MAPPING
  },
  {
    product: "Back pack",
    ids: [8785884578088],
    mapping: BACK_PACK_MAPPING
  },
  {
    product: "Ortho smart bed",
    ids: [8968431370536],
    mapping: ORTHO_SMART_BED_MAPPING
  },
  {
    product: "Ortho lounger",
    ids: [8968431436072],
    mapping: ORTHO_LOUNGER_MAPPING
  },
  {
    product: "Elite smart bed",
    ids: [8968431567144],
    mapping: ORTHO_CALM_ELITE_BED_MAPPING
  },
  {
    product: "Formfit",
    ids: [9018885996840],
    mapping: FORMFIT_MAPPING
  }, 
  
]

/* new label customizations mappings by sudh */
CONVERT_HARNESS_MAPPING_NEW = {
 "S": { patch: "130mm", d_ring: "38mm" },
  "M": { patch: "130mm", d_ring: "38mm" },
  "L": { patch: "158mm", d_ring: "50mm" },
  "XXL": { patch: "158mm", d_ring: "50mm" },
  "XL": { patch: "158mm", d_ring: "50mm" },
  "2XL": { patch: "158mm", d_ring: "50mm" }
}

EXPRESS_HARNESS_MAPPING_NEW = {
  "2XS": { patch: "100mm", d_ring: "25mm" },
  "XS": { patch: "100mm", d_ring: "25mm" },
  "S": { patch: "100mm", d_ring: "25mm" },
  "M": { patch: "130mm", d_ring: "38mm" },
  "L": { patch: "130mm", d_ring: "38mm" },
  "XL": { patch: "158mm", d_ring: "50mm" },
  "2XL": { patch: "158mm", d_ring: "50mm" }
}

SADDLE_BAGS_MAPPING_NEW = {
  "S": { patch: "110mm", d_ring: "25mm" },
  "L": { patch: "158mm", d_ring: "50mm" }
}

BACK_PACK_MAPPING_NEW = {
  "S": { patch: "110mm", d_ring: "" },
  "M": { patch: "110mm", d_ring: "" },
  "L": { patch: "110mm", d_ring: "" }
}
ORTHO_SMART_BED_MAPPING_NEW = {
  "S": { patch: "110mm", d_ring: "" },
  "M": { patch: "130mm", d_ring: "" },
  "L": { patch: "130mm", d_ring: "" },
  "XL": { patch: "130mm", d_ring: "" }
}

ORTHO_LOUNGER_MAPPING_NEW = {
  "M": { patch: "110mm", d_ring: "" },
  "L": { patch: "130mm", d_ring: "" },
  "XL": { patch: "130mm", d_ring: "" }
}

ORTHO_CALM_ELITE_BED_MAPPING_NEW = {
  "M": { patch: "110mm", d_ring: "" },
  "L": { patch: "130mm", d_ring: "" },
  "XL": { patch: "130mm", d_ring: "" }
}

FORMFIT_MAPPING_NEW = {
  "2XS": { patch: "60mm", d_ring: "" },
  "XS": { patch: "60mm", d_ring: "" },
  "S": { patch: "75mm", d_ring: "" },
  "M": { patch: "75mm", d_ring: "" },
  "L": { patch: "95mm", d_ring: "" },
  "XXL": { patch: "95mm", d_ring: "" },
  "2XL": { patch: "95mm", d_ring: "" },
  "XL": { patch: "95mm", d_ring: "" }
}

window.mappingnew = [
  {
    product: "Convert harness",
    ids: [9752306090259, 9752309104915],
    mappingnew: CONVERT_HARNESS_MAPPING_NEW
  },
  {
    product: "Express harness",
    // ids: [8785890935080, 8785901682984, 8785900044584, 8785898307880],
    ids: [9666257781011, 9666243002643],
    mappingnew: EXPRESS_HARNESS_MAPPING_NEW
  },
  {
    product: "Saddle bags",
    ids: [9752298881299],
    mappingnew: SADDLE_BAGS_MAPPING_NEW
  },
  {
    product: "Back pack",
    ids: [9740073042195],
    mappingnew: BACK_PACK_MAPPING_NEW
  },
  {
    product: "Ortho smart bed",
    ids: [9752313266451],
    mappingnew: ORTHO_SMART_BED_MAPPING_NEW
  },
  {
    product: "Ortho lounger",
    ids: [9752313594131],
    mappingnew: ORTHO_LOUNGER_MAPPING_NEW
  },
  {
    product: "Elite smart bed",
    ids: [9752392958227], //[8968431567144],
    mappingnew: ORTHO_CALM_ELITE_BED_MAPPING_NEW
  },
  {
    product: "Formfit",
    // ids: [9018885996840],
    ids: [9891815096595],
    mappingnew: FORMFIT_MAPPING_NEW
  }, 
  
]


let bedding_labels = ["Ortho smart bed", "Ortho lounger", "Elite smart bed"];
let formfit_labels = ["Formfit"];

window.bedding_mapping = window.mapping.filter(item => 
  bedding_labels.includes(item.product)
).map(item => item.ids).flat();

window.formfit_mapping = window.mapping.filter(item => 
  formfit_labels.includes(item.product)
).map(item => item.ids).flat();



$(document).ready(function() {
  $(document).on('change', '#shipping-protection', function() {
    if ($(this).is(':checked')) {
      // Add product to cart
      var variantId = $(this).data('id');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          id: variantId,
          quantity: 1
        },
        dataType: 'json',
        success: function(response) {
          // console.log('Product added to cart:', response);
           handleCartUpdate();
        },
        error: function(error) {
          console.error('Error adding product to cart:', error);
        }
      });
    } else {
      // Remove product from cart
      var removeUrl = $(this).data('remove');
      $.ajax({
        type: 'POST',
        url: removeUrl,
        dataType: 'json',
        success: function(response) {
          // console.log('Product removed from cart:', response);
           handleCartUpdate();
        },
        error: function(error) {
          console.error('Error removing product from cart:', error);
        }
      });
    }
  });

   // Function to reload page or refresh cart drawer
  function handleCartUpdate() {
     // location.reload();
    if ($('body').hasClass('cart')) {
      location.reload();
    } else {
      refreshCartDrawer();
    }
  }

function refreshCartDrawer() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cartContent => {
      // Dispatch the custom event with cart details
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
  bubbles: true
}));
    })
    .catch(error => {
      console.error('Error fetching cart data:', error);
    });
}

});

function removeIcon(event) {
    const emojiRegex = /[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FAFF}\u{1FB00}-\u{1FBFF}]/gu;
    
    const inputElement = $(event.target); // Access the input element
    const inputVal = inputElement.val();

    if (emojiRegex.test(inputVal)) {
        inputElement.val(inputVal.replace(emojiRegex, ''));
    }
}

$(document).on('input', '#cl-custom-text', removeIcon);
$(document).on('input', '#cl-custom-text_order', removeIcon);

/*
  [ED Dev] Manual "Add name label" price rule — DOM patch approach.

  This lives in assets/custom.js (a static asset, not Liquid) because the
  Shopify section render cache keeps serving the pre-fix version of the
  product-upsell-popup.liquid snippet. By rewriting the price text in
  JavaScript AFTER the (cached) HTML has been parsed, we work around that
  cache entirely — no admin-save needed to flush anything.

  Rule:
    - Formfit Mesh Harness  -> "$20.95"
    - Everything else       -> keep default "$27.95"

  We detect Formfit by checking:
    1. window.formfit_mapping (built from window.mapping — has old IDs).
    2. window.mappingnew entry with product === "Formfit" (new IDs).

  Two contexts:
    A) Harness product page (Formfit/Express/etc.) — no #button-wrapper_new
       exists; the ONLY product on the page is the harness itself. We read
       the current product id from an existing hidden marker on the page.
    B) Personalise Side Labels product page — #button-wrapper_new exists
       with data-label-pid. Watch it for Step 1 changes.
*/
(function () {
  var FORMFIT_PRICE = '$20.95';
  var DEFAULT_PRICE = '$27.95';

  // Formfit product IDs. Hardcoded so we don't depend on window.mappingnew
  // being loaded before this runs.
  var FORMFIT_PRODUCT_IDS = [9018885996840, 9891815096595];

  var FORMFIT_SESSION_KEY = 'edLabelStep1Formfit';

  function isFormfitContext(hint, allowSessionFallback) {
    // 1) URL path — simplest and most reliable on a product page.
    var path = (window.location.pathname || '').toLowerCase();
    if (path.indexOf('formfit') !== -1) return true;

    // 2) Step 1 hint (product ID from #button-wrapper_new data-label-pid on
    //    the Personalise Side Labels page).
    var pid = parseInt(hint);
    if (pid && FORMFIT_PRODUCT_IDS.indexOf(pid) !== -1) return true;

    // 3) sessionStorage flag — persists Formfit selection across page
    //    reloads so refreshing the labels page doesn't reset the price.
    //    Only meaningful on the labels page itself: elsewhere (e.g. a
    //    regular harness product page) this flag is stale leftover state
    //    from a previous labels-page visit and must not override the
    //    current page's own product.
    if (allowSessionFallback) {
      try {
        if (sessionStorage.getItem(FORMFIT_SESSION_KEY) === '1') return true;
      } catch (e) {}
    }

    return false;
  }

  function persistContextFor(hint) {
    try {
      var pid = parseInt(hint);
      if (pid && FORMFIT_PRODUCT_IDS.indexOf(pid) !== -1) {
        sessionStorage.setItem(FORMFIT_SESSION_KEY, '1');
      } else if (pid) {
        sessionStorage.removeItem(FORMFIT_SESSION_KEY);
      }
    } catch (e) {}
  }

  function rewritePrices(hint) {
    // Only run on product pages. Collection pages, home, cart etc. must
    // never have their price nodes touched — collection cards show
    // "From $XX.XX" per product's own smallest variant and must remain
    // authoritative.
    if ((window.location.pathname || '').indexOf('/products/') !== 0) return;

    var pathIsLabels = /(personalise|personalised|label)/i.test(window.location.pathname);
    var price = isFormfitContext(hint, pathIsLabels) ? FORMFIT_PRICE : DEFAULT_PRICE;

    // 1) Header/summary spans that contain ONLY a dollar amount.
    var moneyOnly = [
      '#upsell-popup-price',
      '#upsell-popup-custom-price',
      '#upsell-customise-price',
      '.second-section p span'
    ];
    document.querySelectorAll(moneyOnly.join(',')).forEach(function (el) {
      var t = (el.textContent || '').trim();
      if (/^\$?\d+(\.\d{1,2})?$/.test(t)) {
        el.textContent = ' ' + price;
      }
    });

    // 2) ATC button labels ("ADD TO CART - $X.XX") + <sale-price> —
    //    ONLY run on the Personalise Side Labels product page. On an
    //    individual harness product page, the popup's own JS already
    //    calculates "product + label" totals correctly, and rewriting
    //    the ATC to just the label price would break that.
    var regexTargets = [];
    if (pathIsLabels) {
      regexTargets.push(
        '#add-patch-text_new',
        '#add-patch-text_new1',
        '#add-patch-text_order',
        '#add-patch-text_order1',
        // Scope tightly to the main product's price container so we DON'T
        // touch cart drawer / cart page line-item prices, which come from
        // the actual (correct) variant price.
        '#product-price-list sale-price'
      );
    }
    if (!regexTargets.length) return;
    document.querySelectorAll(regexTargets.join(',')).forEach(function (el) {
      var t = el.textContent || '';
      if (/\$\d+(\.\d{1,2})?/.test(t)) {
        // Use a function replacement so `price` is treated literally.
        // Passing a string like "$20.95" would let JS interpret "$1" as
        // the first capture group (".95"), producing ".9520.95".
        el.textContent = t.replace(/\$\d+(\.\d{1,2})?/, function () { return price; }).replace('Sale price', '');
      }
    });
  }

  function boot() {
    var wrapper = document.getElementById('button-wrapper_new');
    rewritePrices(wrapper ? wrapper.getAttribute('data-label-pid') : null);

    // Watch Step 1 changes on the labels page.
    if (wrapper) {
      persistContextFor(wrapper.getAttribute('data-label-pid'));
      new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          if (m.type === 'attributes' && m.attributeName === 'data-label-pid') {
            var newPid = wrapper.getAttribute('data-label-pid');
            persistContextFor(newPid);
            rewritePrices(newPid);
          }
        });
      }).observe(wrapper, { attributes: true, attributeFilter: ['data-label-pid'] });
    }

    // [ED Dev] On HARNESS product pages, keep popup ATC total in sync with
    // the currently-selected variant price. The popup writes the selected
    // variant's price into `.cpricesnew` on colour/size click. We observe
    // that node and rewrite the ATC to (variantPrice + labelPrice) — this
    // works even if the popup's own click handler fails to update the ATC.
    var pathIsLabelsForSync = /(personalise|personalised|label)/i.test(window.location.pathname);
    if (!pathIsLabelsForSync) {
      var labelPrice = isFormfitContext(null, false) ? parseFloat(FORMFIT_PRICE.replace('$', '')) : parseFloat(DEFAULT_PRICE.replace('$', ''));

      function syncAtcFromCpricesnew() {
        var priceEl = document.querySelector('.cpricesnew');
        if (!priceEl) return;
        var m = (priceEl.textContent || '').match(/\$([\d]+(?:\.\d{1,2})?)/);
        if (!m) return;
        var variantPrice = parseFloat(m[1]);
        if (isNaN(variantPrice)) return;
        var sum = variantPrice + labelPrice;
        document.querySelectorAll('#add-patch-text_new, #add-patch-text_new1, #add-patch-text_order, #add-patch-text_order1').forEach(function (el) {
          el.textContent = 'ADD TO CART - $' + sum.toFixed(2);
        });
      }

      var cpricesnewEl = document.querySelector('.cpricesnew');
      if (cpricesnewEl) {
        syncAtcFromCpricesnew();
        new MutationObserver(syncAtcFromCpricesnew).observe(cpricesnewEl, { childList: true, characterData: true, subtree: true });
      }
    }

    // Safety net: some snippets rebuild the price node after DOMContentLoaded.
    // Re-run a few times so we always win.
    setTimeout(function () { rewritePrices(wrapper ? wrapper.getAttribute('data-label-pid') : null); }, 500);
    setTimeout(function () { rewritePrices(wrapper ? wrapper.getAttribute('data-label-pid') : null); }, 1500);
    setTimeout(function () { rewritePrices(wrapper ? wrapper.getAttribute('data-label-pid') : null); }, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();